var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Pane, MenuSection, IconButton, } from "@folio/stripes/components";
import { StripesConnectedSource, } from "@folio/stripes/smart-components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekSelect } from "../../components/inputs";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import { searchPublishers } from "../../api/publisherService";
import { usePermissions } from "../../hooks/usePermissions";
import { usePublisherQuery } from "../../hooks/usePublisherQuery";
import { usePageSize } from "../../hooks/usePageSize";
import PublisherDetail from "../publishers/PublisherDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { formatDate } from "../../utils/dateTimeUtil";
import { DataListPane } from "../../components/DataListPane";
import { formatRegistrationsSummary, getActiveRegistrations, } from "../../utils/registrationUtils";
var DEFAULT_FILTERS = {
    registrationAgency: "",
    registrationIntent: "ONE_OFF",
    status: ["REQUEST"],
};
var PublisherRegistrationsList = function () {
    var _a;
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var canApprovePublisherRegistration = usePermissions().canApprovePublisherRegistration;
    var formatMessage = useIntl().formatMessage;
    var detailId = new URLSearchParams(location.search).get("detail");
    var selectedPublisherRegister = usePublisherQuery(detailId).data;
    var _b = useState(true), filterPaneIsVisible = _b[0], setFilterPaneIsVisible = _b[1];
    var _c = useState(0), pageOffset = _c[0], setPageOffset = _c[1];
    var _d = usePageSize(function () {
        return setPageOffset(0);
    }), pageSize = _d.pageSize, handlePageSizeChange = _d.handlePageSizeChange;
    var _e = useState(0), totalRecords = _e[0], setTotalRecords = _e[1];
    var _f = useState(DEFAULT_FILTERS), filters = _f[0], setFilters = _f[1];
    var _g = useState("ONE_OFF"), registrationIntentFilter = _g[0], setRegistrationIntentFilter = _g[1];
    var _h = useState(""), registrationAgencyFilter = _h[0], setRegistrationAgencyFilter = _h[1];
    var updateUrlWithFilters = function (filters) {
        var params = new URLSearchParams();
        if (filters.registrationAgency)
            params.set("registrationAgency", filters.registrationAgency);
        if (filters.registrationIntent)
            params.set("registrationIntent", filters.registrationIntent);
        history.push({ search: params.toString() });
    };
    var _j = useQuery(["publishers", filters, pageOffset, pageSize], function () {
        return searchPublishers(ky, __assign(__assign({}, filters), { offset: pageOffset, limit: pageSize }));
    }, {
        keepPreviousData: true,
        onSuccess: function (data) {
            setTotalRecords(data.totalRecords);
        },
    }), data = _j.data, isLoading = _j.isLoading, isError = _j.isError, isFetched = _j.isFetched;
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    var publisherRegistrationsData = (_a = data === null || data === void 0 ? void 0 : data.publishers) !== null && _a !== void 0 ? _a : [];
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var columns = [
        {
            name: formatMessage({ id: "ui-br-publishers.registration.label" }),
            key: "registrations",
            cellRenderer: function (item) {
                return formatRegistrationsSummary(formatMessage, getActiveRegistrations(item));
            },
        },
        {
            name: formatMessage({
                id: "ui-br-publishers.publishers.table.columns.name",
            }),
            key: "name",
            clickable: true,
            onClick: function (item) {
                var currentParams = new URLSearchParams(location.search);
                currentParams.delete("detail");
                history.push({
                    search: "".concat(currentParams.toString(), "&detail=").concat(item.id),
                });
            },
        },
        {
            name: formatMessage({
                id: "ui-br-publishers.publisher.registrations.table.dateOfRegistration",
            }),
            key: "createTime",
            cellRenderer: function (item) {
                return item.createTime ? formatDate(item.createTime) : "N/A";
            },
        },
    ];
    var source = new StripesConnectedSource({}, ky);
    source.update = function () { };
    source.records = function () { return publisherRegistrationsData; };
    source.resultCount = function () { return publisherRegistrationsData.length; };
    source.totalCount = function () { return totalRecords; };
    source.pending = function () { return isLoading; };
    source.loaded = function () { return isFetched; };
    source.failure = function () { return (isError ? { message: "Error loading data" } : null); };
    source.failureMessage = function () { return "Error loading data"; };
    source.fetchMore = fetchMoreData;
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-publishers.pane.title.navigation",
            }), lastMenu: filterPaneIsVisible ? (React.createElement(IconButton, { icon: "caret-left", onClick: toggleFilterPane, "aria-label": formatMessage({
                    id: filterPaneIsVisible
                        ? "ui-br-publishers.filter.hide"
                        : "ui-br-publishers.filter.show",
                }), style: { marginLeft: "auto" } })) : (React.createElement(React.Fragment, null)) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null),
                React.createElement("form", { onSubmit: function (e) {
                        e.preventDefault();
                        var payload = __assign(__assign({}, filters), { registrationAgency: registrationAgencyFilter, registrationIntent: registrationIntentFilter });
                        setPageOffset(0);
                        setFilters(payload);
                        updateUrlWithFilters(payload);
                    } },
                    React.createElement(RecekSelect, { labelId: "ui-br-publishers.registration.agency", dataOptions: [
                            {
                                label: formatMessage({
                                    id: "ui-br-publishers.registration.agency.all",
                                }),
                                value: "",
                            },
                            { label: "ISBN", value: "ISBN" },
                            { label: "ISMN", value: "ISMN" },
                        ], value: registrationAgencyFilter, onChange: function (e) {
                            return setRegistrationAgencyFilter(e.target.value);
                        } }),
                    React.createElement(RecekSelect, { labelId: "ui-br-publishers.registration.intent", dataOptions: [
                            {
                                label: formatMessage({
                                    id: "ui-br-publishers.registration.intent.one_off",
                                }),
                                value: "ONE_OFF",
                            },
                            {
                                label: formatMessage({
                                    id: "ui-br-publishers.registration.intent.continuous",
                                }),
                                value: "CONTINUOUS",
                            },
                        ], value: registrationIntentFilter, onChange: function (e) {
                            return setRegistrationIntentFilter(e.target.value);
                        } }),
                    React.createElement(Button, { type: "submit", marginBottom0: true },
                        React.createElement(FormattedMessage, { id: "ui-br-publishers.button.apply" })))))),
        React.createElement(DataListPane, { paneId: "contentPane", paneTitle: formatMessage({
                id: "ui-br-publishers.publisher.registrations.pane.title",
            }), paneSub: formatMessage({ id: "ui-br-publishers.publishers.table.subtitle.records-found" }, { count: totalRecords }), filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane },
            React.createElement(TableComponent, { data: publisherRegistrationsData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: totalRecords, pagingOffset: pageOffset, onNeedMoreData: function (offset) {
                    fetchMoreData(offset);
                }, filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, pagingType: "prev-next" })),
        selectedPublisherRegister && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                id: "ui-br-publishers.publisher.registrations.detail.pane.title",
            }), onClose: function () {
                var queryParams = new URLSearchParams(location.search);
                queryParams.delete("detail");
                history.replace({ search: queryParams.toString() });
            }, dismissible: true, actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                    id: "ui-br-publishers.menu.label.actions",
                }), id: "actions-menu" },
                canApprovePublisherRegistration && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        return history.push("/brpublishers/publisher-registrations/approval/".concat(selectedPublisherRegister.id));
                    }, fullWidth: true }, formatMessage({
                    id: "ui-br-publishers.publishers.menu.label.approveReject",
                }))),
                canApprovePublisherRegistration && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                        return history.push("/brpublishers/publisher-registrations/restore/".concat(selectedPublisherRegister.id));
                    }, fullWidth: true }, formatMessage({
                    id: "ui-br-publishers.publishers.menu.label.restore",
                }))))); } }, selectedPublisherRegister ? (React.createElement(PublisherDetail, { publisher: selectedPublisherRegister })) : (React.createElement("div", null, "No details available"))))));
};
export default PublisherRegistrationsList;
